module.exports = __webpack_public_path__ + "img/4.bc9a16ab.jpg";